var map = {
	"./404.svg": 4316,
	"./adminbackground.png": 2973,
	"./background1.webp": 2190,
	"./background2.webp": 4127,
	"./background3.webp": 9836,
	"./background4.webp": 3165,
	"./decorate_circles.svg": 6203,
	"./microBackground1.webp": 9032,
	"./microBackground2.webp": 1461,
	"./microBackground3.webp": 9594,
	"./microBackground4.webp": 9079,
	"./slide.jpg": 4719,
	"./slide2.png": 6525,
	"./slide2.webp": 9806,
	"./slide2_black.png": 4809,
	"./slide_black.png": 683,
	"./vacancy.webp": 2456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3680;